import { getGivenAnonymously } from "./getDataLayerOptionsHelpers";

/**
 * @typedef {import("@qgiv/donation-form").SelectorTypes.Fields.DetailsPageFieldsData} DetailsPageFieldsData
 * @typedef {import("@qgiv/donation-form").ReduxTypes.DonationDetails.DonorDetails} DonorDetails
 * @typedef {import("@qgiv/donation-form").ReduxTypes.FormSettings.FormSettings} FormSettings
 * @typedef {import("@qgiv/donation-form").ReduxTypes.Receipts.Receipt} Receipt
 * @typedef {import("@qgiv/donation-form").UtilityTypes.DataLayer.ContactOptions} ContactOptions
 */

/**
 *
 * @param {object} options
 * @param {DetailsPageFieldsData} options.detailsPageFieldsData
 * @param {DonorDetails} options.donorDetails
 * @param {FormSettings} options.formSettings
 * @returns {ContactOptions|{}}
 */
export const getContactOptionsMultiStep = ({
    detailsPageFieldsData,
    donorDetails,
    formSettings,
}) => {
    const hasDonorDetails = Object.keys(donorDetails).length > 0;
    const hasDetailsPageFieldsData =
        Object.keys(detailsPageFieldsData).length > 0;
    let contactOptions = {};

    if (!hasDonorDetails && !hasDetailsPageFieldsData) {
        return contactOptions;
    }

    // Extract data from state
    const { defaultOptInChecked } = detailsPageFieldsData;

    // Assign values to remaining keys specified by documentation
    // Need to pay attention to the default value for the opt in field as
    // is the only field here whose value can actually be checked by default.
    // Other than that the default values of all of the remaining fields cannot
    // be modified once they are active.
    const defaultOptInValue =
        !!defaultOptInChecked.exists && !!defaultOptInChecked.checkedByDefault;
    const {
        Company = "",
        Email = "",
        First_Name = "",
        Last_Name = "",
        Opt_In = defaultOptInValue,
    } = donorDetails;
    const company = Company;
    const email = Email;
    const firstName = First_Name;
    const givenAnonymously = getGivenAnonymously(donorDetails, formSettings);
    const lastName = Last_Name;
    const optedIn = Opt_In;

    contactOptions = {
        company,
        email,
        firstName,
        givenAnonymously,
        lastName,
        optedIn,
    };

    return contactOptions;
};

/**
 * @param {Receipt & { transaction: NonNullable<Receipt['transaction']>} } receipt
 * @returns {ContactOptions|{}}
 */
export const getContactOptionsSingleStep = (receipt) => {
    const { transaction } = receipt;

    const company = transaction.company || "";
    const email = transaction.email || "";
    const firstName = transaction.fname || "";
    const lastName = transaction.lname || "";
    const givenAnonymously = transaction.anonymous === "y";
    const optedIn = transaction.optIn === "y";

    const contactOptions = {
        company,
        email,
        firstName,
        givenAnonymously,
        lastName,
        optedIn,
    };

    return contactOptions;
};
